import {
  Sidebar,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarScrollWrapper,
  SidebarSpace,
} from '@backstage/core-components';
import {
  NavContentBlueprint,
  type NavContentNavItems,
} from '@backstage/plugin-app-react';
import { SidebarLogo } from './SidebarLogo';
import { RiHomeLine, RiMenuLine, RiSearchLine } from '@remixicon/react';
import { SidebarSearchModal } from '@backstage/plugin-search';
import { UserSettingsSignInAvatar } from '@backstage/plugin-user-settings';
import { NotificationsSidebarItem } from '@backstage/plugin-notifications';

export interface PortalSidebarProps {
  navItems: NavContentNavItems;
}

export const PortalSidebar = ({ navItems }: PortalSidebarProps) => {
  const nav = navItems.withComponent(item => {
    const isHome = item.node.spec.id === 'page:home';
    const text = isHome ? 'Home' : item.title;
    const Icon = isHome ? () => <RiHomeLine /> : () => item.icon;
    return <SidebarItem icon={Icon} to={item.href} text={text} />;
  });

  nav.take('page:search');
  nav.take('page:notifications');
  // Keep /catalog-graph reachable from entity cards, but out of the main menu.
  nav.take('page:catalog-graph');
  // Keep /catalog-import reachable from register bindings, but out of the main menu.
  nav.take('page:catalog-import');

  const visualizerItem = nav.take('page:app-visualizer');
  const settingsItem = nav.take('page:user-settings');

  return (
    <Sidebar>
      <SidebarLogo />
      <SidebarGroup label="Search" icon={<RiSearchLine />} to="/search">
        <SidebarSearchModal />
      </SidebarGroup>
      <SidebarDivider />
      <SidebarGroup label="Menu" icon={<RiMenuLine />}>
        {nav.take('page:home')}
        {nav.take('page:catalog')}
        {nav.take('page:api-docs')}
        {nav.take('page:techdocs')}
        {nav.take('page:scaffolder')}
        <SidebarDivider />
        <SidebarScrollWrapper>
          {nav.rest({ sortBy: 'title' })}
        </SidebarScrollWrapper>
      </SidebarGroup>
      <SidebarSpace />
      <SidebarDivider />
      <NotificationsSidebarItem />
      <SidebarDivider />
      <SidebarGroup
        label="Settings"
        icon={<UserSettingsSignInAvatar />}
        to="/settings"
      >
        {visualizerItem}
        {settingsItem}
      </SidebarGroup>
    </Sidebar>
  );
};

export const SidebarContent = NavContentBlueprint.make({
  params: {
    component: PortalSidebar,
  },
});
